module.exports = __webpack_public_path__ + "static/media/wifi_off.cf79f907.svg";